export default (text, value) => ({
  text,
  value
});
